import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { IDerivativeSearchModel } from '../models/derivative-search-model';
import { ISearchResultModel } from '../models/search-result-model';

export const DerivativeSearchToken = new InjectionToken<IDerivativeSearchService>("DerivativeSearchToken");

export interface IDerivativeSearchService {
  derivativeSearch(searchModel: IDerivativeSearchModel): Observable<ISearchResultModel>;
}
